module.exports = __webpack_public_path__ + "static/media/helsinki-logo.cd0b2a23.png";